import { ScoreCard } from '../../lib/types/models/score-card/score-card'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffApplicationCurrentScoreCard(applicationId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.candidate.getStaffApplicationCurrentScoreCard.url, { id: applicationId })
    )
    .get<ScoreCard>()
}
